module.exports = __webpack_public_path__ + "media/application/images/icons/icon-replanting-7b349b54abd43187a5c17cc41e7f9500.svg";